/**
 * [INPUT]: 依赖 React、ReactDOM、路由与身份上下文
 * [OUTPUT]: 对外启动 admin-web 单页应用并注入全局样式
 * [POS]: admin-web 运行时入口，负责组装应用级 Provider
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/auth';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
